import request from '@/assets/js/request';

/**
 * @description 获取白名单详情
 */

export async function detailAction(params){
    return request({
        url: '/userBlank/detail',
        method: 'post',
        data: params
    })
}

/**
 * @description 编辑白名单
 */

export async function editAction(params){
    return request({
        url: '/userBlank/edit',
        method: 'post',
        data: params
    })
}

/**
 * @description 新增白名单
 */

export async function addAction(params){
    return request({
        url: '/userBlank/add',
        method: 'post',
        data: params
    })
}